export const knowledgeBaseLocaleDict = {
    ru: {
        showNavigation: 'Показать навигацию',
        hideNavigation: 'Скрыть навигацию',
        lessonPlaceholder: 'Здесь скоро будет обучающий урок..',
        documentStatus: 'Статус документа',
        studyTime: 'Общее время на изучение (ЧЧ:ММ)',
        responsible: 'Ответственный'
    },
    en: {
        showNavigation: 'Show navigation',
        hideNavigation: 'Hide navigation',
        lessonPlaceholder: 'A training lesson will be here soon..',
        documentStatus: 'Document status',
        studyTime: 'Total study time (HH:MM)',
        responsible: 'Responsible'
    },
    th: {
        showNavigation: 'แสดงการนำทาง',
        hideNavigation: 'ซ่อนการนำทาง',
        lessonPlaceholder: 'บทเรียนการฝึกอบรมจะมาเร็วๆ นี้..',
        documentStatus: 'สถานะเอกสาร',
        studyTime: 'เวลาเรียนทั้งหมด (ชช:นน)',
        responsible: 'ผู้รับผิดชอบ'
    },
    tr: {
        showNavigation: 'Gezinmeyi göster',
        hideNavigation: 'Gezinmeyi gizle',
        lessonPlaceholder: 'Yakında burada bir eğitim dersi olacak..',
        documentStatus: 'Belge durumu',
        studyTime: 'Toplam çalışma süresi (SS:DD)',
        responsible: 'Sorumlu'
    }
};
